import { breakpointMd } from '@farol-ds/tokens'
import { useLayoutEffect, useRef } from 'react'

export function useFirstStepHeight(isSecondStep: boolean) {
  const contentRef = useRef<HTMLDivElement>(null)
  const firstStepHeightRef = useRef<number | undefined>(undefined)

  // No dependency array — runs every render to capture the latest first-step
  // height after any content/layout change (e.g. async cards loading).
  useLayoutEffect(() => {
    if (!isSecondStep && contentRef.current && window.innerWidth >= breakpointMd) {
      firstStepHeightRef.current = contentRef.current.offsetHeight
    }
  })

  return { contentRef, firstStepHeight: firstStepHeightRef.current }
}
